import { create } from "zustand";

/**
 * AI Context state interface.
 * Manages active panel state and input values across the application.
 */
export interface AIContextState {
  /** Currently active panel identifier */
  activePanel: string | null;
  /** Key-value pairs for storing input data */
  inputs: Record<string, any>;
  /** Set the active panel */
  setActivePanel: (p: string) => void;
  /** Set an input value by key */
  setInput: (key: string, value: any) => void;
}

/**
 * Zustand store for AI context management.
 * Tracks which panel is active and stores context-specific input data.
 */
export const useAIContext = create<AIContextState>((set) => ({
  activePanel: null,
  inputs: {},
  setActivePanel: (p) => set({ activePanel: p }),
  setInput: (key, value) =>
    set((state) => {
      // Only update if value actually changed to prevent infinite loops
      if (state.inputs[key] === value) return state;
      return {
        inputs: { ...state.inputs, [key]: value },
      };
    }),
}));







